import { render, staticRenderFns } from "./ComparePageDeleteItem.vue?vue&type=template&id=44129062&"
import script from "./ComparePageDeleteItem.vue?vue&type=script&lang=js&"
export * from "./ComparePageDeleteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports